'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _ArrowButton = require('./ArrowButton.component');

var _ArrowButton2 = _interopRequireDefault(_ArrowButton);

require('../styles/TouchArrowButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TouchArrowButton = function (_BcReactComponent) {
  _inherits(TouchArrowButton, _BcReactComponent);

  function TouchArrowButton() {
    _classCallCheck(this, TouchArrowButton);

    return _possibleConstructorReturn(this, (TouchArrowButton.__proto__ || Object.getPrototypeOf(TouchArrowButton)).apply(this, arguments));
  }

  _createClass(TouchArrowButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentPage = _props.currentPage,
          direction = _props.direction,
          disabled = _props.disabled,
          handleClick = _props.handleClick,
          pageSize = _props.pageSize,
          numberOfItems = _props.numberOfItems;


      return _react2.default.createElement(_ArrowButton2.default, {
        className: 'cp-touch-arrow-button',
        disabled: disabled,
        handleClick: handleClick,
        currentPage: currentPage,
        pageSize: pageSize,
        numberOfItems: numberOfItems,
        direction: direction });
    }
  }]);

  return TouchArrowButton;
}(_baseBcReactComponent2.default);

exports.default = TouchArrowButton;


TouchArrowButton.propTypes = {
  currentPage: _react.PropTypes.number,
  pageSize: _react.PropTypes.number,
  numberOfItems: _react.PropTypes.number,
  direction: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  handleClick: _react.PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/carousel/base-carousel/lib/components/TouchArrowButton.component.js
// module id = 545
// module chunks = 3 5 6 7